import { render, staticRenderFns } from "./goal.vue?vue&type=template&id=009ebb5b&scoped=true&"
import script from "./goal.vue?vue&type=script&lang=js&"
export * from "./goal.vue?vue&type=script&lang=js&"
import style0 from "./goal.vue?vue&type=style&index=0&id=009ebb5b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009ebb5b",
  null
  
)

export default component.exports